import _ from 'lodash';
import k from '@gral/constants';
import act from '@flux/actions/actView';
import moment from 'moment';

// This class implements the "needs" behavior without being a React Component
// this way the class is decoupled from react lifecycles.
// The main reason of this implementation is that "UNSAFE_componentWillMount" lifecycle
// will be deprecated in future versions of react

export default class NeedsManager {
  constructor(dataStorage, needs = []) {
    this._myNeeds = needs;
    this._requested = [];
    this._dataStorage = dataStorage;
  }

  setDataStorage(dataStorage) {
    this._dataStorage = dataStorage;
  }

  fetchNeeds() {
    const pending = [];
    this._myNeeds.forEach(need => {
      const rsrc = this._dataStorage?.get(need.dataPath);
      if ((rsrc === undefined || rsrc === null) && _.indexOf(this._requested, need.dataPath) === -1) {
        pending.push(need);
        this._requested.push(need.dataPath);
      } else if (rsrc !== undefined && rsrc !== null) {
        const shouldRefresh =
          !rsrc.get('state') === k.rsrcStates.SYNCING ||
          (rsrc.get('fStale') && rsrc.get('state') === k.rsrcStates.IDLE && rsrc.get('errors').size === 0) ||
          (need.refreshPeriod &&
            moment().subtract(need.refreshPeriod, 'seconds') > moment(rsrc.get('date')) &&
            rsrc.get('state') === k.rsrcStates.IDLE &&
            rsrc.get('errors').size === 0);
        if (shouldRefresh) {
          pending.push(need);
        }
      }
    });

    if (pending.length) {
      act.fetchMultiple(pending);
    }
  }

  iNeed(need) {
    const alreadyInQueue = this._myNeeds.find(needInQueue => needInQueue.dataPath === need.dataPath);
    if (!alreadyInQueue) {
      this._myNeeds.push(need);
    }
  }

  concatArrays = (...arrays) => arrays.reduce((result, array) => result.concat(array), []);
}
